import TermsOfServiceContent from "$lib/data/generated/content/terms of service/data.json";

import { uploads as TermsOfServiceUploads } from "$lib/data/generated/uploads/terms of service/uploads";

const content = {
	["terms of service"]: TermsOfServiceContent
};
const uploads = {
	...TermsOfServiceUploads
};


export const prerender = 'auto';
export const entries = () => {
	if (false) return [];
	return ['/admin'];
};

export const load = async ({ parent }) => {
	const data = await parent();

	data.content = { ...data.content, ...content };
	data.uploads = { ...data.uploads, ...uploads };

	return data;
};
